import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// import i18n (needs to be bundled ;)) 
import i18n from './i18n';

// use 'redux'
import store from './store'
import { Provider } from 'react-redux';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}> 
        <App />
    </Provider>
  </BrowserRouter>
);